import { createSlice } from '@reduxjs/toolkit';

export const profiledetailSlice = createSlice({
  name: 'profiledetails',
  initialState: {
    data: [],
  },
  reducers: {
    setProfile: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setProfile} = profiledetailSlice.actions;

export default profiledetailSlice.reducer;
